import { render, staticRenderFns } from "./NoteView.vue?vue&type=template&id=60c77fba&scoped=true"
import script from "./NoteView.vue?vue&type=script&lang=js"
export * from "./NoteView.vue?vue&type=script&lang=js"
import style0 from "./NoteView.vue?vue&type=style&index=0&id=60c77fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c77fba",
  null
  
)

export default component.exports